<template>
  <div :class="['modal-card has-modal-large', $style.modalContainer]">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ gripAnalysis ? gripAnalysis.title : 'GRiP Analysis Details' }}
      </p>
      <button @click="$emit('close')" type="button" class="close-icon">
        <i class="mdi mdi-close"></i>
      </button>
    </header>

    <section :class="['modal-card-body', $style.modalBodyContainer]">
      <p-data-table
        :data="analysisCriteria ? analysisCriteria : []"
        :hoverable="true"
        :borderless="true"
        :radiusless="true"
        :shadowless="true"
        :noDataText="`No criteria found`"
        :class="$style.table"
      >
        <template slot="thead">
          <tr :class="$style.tableHeadRow">
            <th :class="$style.tableHeader">Criteria</th>
          </tr>
        </template>
        <template slot="tbody" slot-scope="{ data }">
          <tr
            v-for="(criteria, index) in data"
            :key="`active${criteria.id}`"
            :class="$style.tableBodyRow"
          >
            <td :class="$style.criteriaColumn">
              <div class="margin-right4">{{ `${index + 1}.` }}</div>
              <div :class="$style.criteriaTitle">
                <span :class="$style.documentId">
                  {{ criteria.documentId }}
                </span>
                {{ criteria.title }}
              </div>
            </td>
          </tr>
        </template>
      </p-data-table>
    </section>

    <footer class="modal-card-foot">
      <button
        class="button is-large is-rounded is-primary bold"
        @click="$emit('close')"
      >
        Done
      </button>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ProjectCriteria } from '../../../store/modules/projects/types/projects.types';
import { GripAnalysis } from '../../../store/types/grip.types';
import ExportGripReportModalAnalysisList from './ExportGripReportModalAnalysisList.vue';

@Component({
  components: {
    ExportGripReportModalAnalysisList,
  },
})
export default class ViewGripAnalysisDetailsModal extends Vue {
  @Prop() public gripAnalysis!: GripAnalysis;

  get analysisCriteria(): ProjectCriteria[] {
    return this.gripAnalysis.gripAnalysisCriteriaMaps
      .filter((criteriaMap) => !criteriaMap.criteria.isDeleted)
      .map((criteriaMap) => criteriaMap.criteria);
  }
}
</script>

<style lang="scss" module>
.modalContainer {
  max-height: 720px;
}

.modalBodyContainer {
  padding: 20px 32px;
}

.selectedCount {
  margin-bottom: 10px;
  color: #9f9f9f;
}

.tableHeadRow {
  border-bottom: 1px solid $grey-border;
}

.tableBodyRow {
  border-bottom: 1px solid $grey-border;
}

.tableHeader {
  font-weight: bold !important;
  color: #444f51 !important;
}

.criteriaColumn {
  display: flex;
  line-height: 20px;

  .criteriaTitle {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: initial;
  }

  .documentId {
    font-weight: 500;
    margin-right: 4px;
  }
}
</style>
